var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoinEvent2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9388 6.71276C21.4784 7.29569 21.6539 8.61966 21.6539 8.61966C21.6539 8.61966 21.834 10.1732 21.834 11.7273V13.1835C21.834 14.7376 21.6539 16.2912 21.6539 16.2912C21.6539 16.2912 21.4778 17.6146 20.9388 18.1964C20.3214 18.8853 19.6373 18.9568 19.2509 18.9972C19.2087 19.0016 19.17 19.0056 19.1354 19.01C16.6163 19.203 12.834 19.2098 12.834 19.2098C12.834 19.2098 8.15365 19.1642 6.71376 19.0168C6.64561 19.0032 6.56305 18.9926 6.46958 18.9806C6.01358 18.922 5.29796 18.83 4.7292 18.1958C4.1896 17.614 4.01404 16.2906 4.01404 16.2906C4.01404 16.2906 3.83398 14.7376 3.83398 13.183V11.7268C3.83398 10.1732 4.01404 8.61966 4.01404 8.61966C4.01404 8.61966 4.19016 7.29569 4.7292 6.71276C5.34926 6.02142 6.03565 5.95189 6.42123 5.91283C6.46182 5.90872 6.49908 5.90494 6.53258 5.90081C9.05111 5.70557 12.8295 5.70557 12.8295 5.70557H12.8379C12.8379 5.70557 16.6163 5.70557 19.1354 5.90081C19.1689 5.90494 19.2062 5.90872 19.2468 5.91283C19.6325 5.9519 20.3192 6.02145 20.9388 6.71276ZM10.5854 15.8334V9.08129L16.2122 12.4573L10.5854 15.8334Z",
    fill: "#0B0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinEvent2023);
export default __webpack_public_path__ + "static/media/bitcoin-event-2023.83f602e97b67b130409373bbf11fe1cb.svg";
export { ForwardRef as ReactComponent };